import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Поможем подобрать \nфинансовый продукт',
  subtitle: 'Закажите звонок и наш менеджер перезвонит вам',
  form: {
    name: {
      placeholder: 'Ваше имя',
    },
    phone: {
      placeholder: 'Введите ваш телефон',
    },
    actions: {
      submit: 'Заказать звонок',
    },
    errors: {
      require: 'Обязательное поле',
      maxLength: 'Максимальная длина поля {length} символов',
    },
    requiredInfo: '* Обязательное поле',
    agreement: {
      text: 'Ввод номера телефона подтверждает ваше согласие с {link}',
      link: 'политикой обработки персональных данных',
    },
  },
} as const satisfies TMessages
